import { ArrowPathIcon } from "@heroicons/react/20/solid";
import Image from "next/image";

const LoadingHero = () => {
  return (
    <div className="herocard-root">
      <div className="herocard-body flex items-center justify-center">
        <Image
          src="/image/paw/paw.svg"
          alt="paw"
          height={55}
          width={55}
          className="h-auto w-auto animate-ping"
        />
      </div>

      <div className="herocard-nav">
        <span className="herocard-nav-btn opacity-0">
          <ArrowPathIcon className="size-4 flex-none" />
        </span>
        <span className="herocard-nav-btn opacity-0">
          <ArrowPathIcon className="size-4 flex-none" />
        </span>
      </div>
    </div>
  );
};

export default LoadingHero;
